module.exports = __webpack_public_path__ + "img/swper4.717b9c38.png";